<template>
  <div class="page-content">
    <div class="headings">
      <h2 class="title title-primary">
        {{ $t("lang.online.order_boxes.page_title_line_1") }}
      </h2>
      <span>|</span>
      <h3 class="title title-primary">
        {{ $t("lang.online.order_boxes.page_title_line_2") }}
      </h3>
    </div>
    <div class="page-header">
      <div class="boxes" v-if="!shouldLoading">
        <bx-box
          dark
          color="outline"
          :title="$t('lang.online.order_boxes.box_title_1')"
          class="col-12 col-md-6 col-lg-auto p-1"
        >
          <template slot="actions">
            <bx-order-status
              :status="order_status"
              dark
            ></bx-order-status>
          </template>
          <div class="detail-titles">
            <div class="wrapper">
              <h4>
                Nº
                <strong>{{ id }}</strong>
              </h4>
              <h5>
                <strong>{{ name }}</strong>
              </h5>
            </div>
          </div>
        </bx-box>

        <bx-box dark color="outline" class="col-6 col-md-6 col-lg-auto p-1">
          <bx-value
            :label="$t('lang.online.order_boxes.box_label_2')"
            :value="exit_date"
            font-size="xs"
          />
        </bx-box>

        <bx-box
          dark
          color="outline"
          class="col-6 col-md-4 col-lg-auto p-1 bx-box-adjustable"
        >
          <bx-value
            :label="$t('lang.online.order_boxes.box_label_3')"
            :value="waitingTime"
            font-size="xs"
          />
        </bx-box>

        <bx-box dark color="outline" class="col-6 col-md-4 col-lg-auto p-1">
          <bx-value
            :label="$t('lang.online.order_boxes.box_label_4')"
            :value="`${orderData.real_item_count} / ${orderData.item_count}`"
            font-size="xs"
          />
        </bx-box>

        <bx-box dark color="outline" class="col-6 col-md-4 col-lg-auto p-1">
          <bx-value
            :label="$t('lang.online.order_boxes.box_label_5')"
            :value="`${orderData.num_verified_boxes} / ${orderData.num_boxes}`"
            font-size="xs"
          />
        </bx-box>
      </div>
      <skeleton-boxes :boxes="5" v-else />
    </div>

    <div class="page-main-content">
      <div class="container-fluid">
        <div class="row" style="margin: 8px">
          <bx-btn @click="$router.back()">{{
            $t("lang.messages.go_back")
          }}</bx-btn>
        </div>
        <v-row class="d-flex d-sm-none">
          <v-list width="100%">
            <v-list-item
              two-line
              v-for="(item, index) in data"
              :key="index"
              class="green lighten-5 ma-2 rounded-lg"
              ripple
              :to="{
                name: 'Sale_BoxVerificationView',
                params: { orderId: orderId, boxId: id, id: item.id }
              }"
            >
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.id }}
                </v-list-item-title>
                <v-list-item-title class="text-caption">
                  {{ item.start_time }}
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-list-item-subtitle class="text-caption">
                  {{ item.real_item_count }}
                </v-list-item-subtitle>
                <v-list-item-subtitle class="text-caption">
                  {{ item.end_time }}
                </v-list-item-subtitle>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-row>
        <div class="row">
          <bx-box
            :title="
              totalVerifications +
                ' ' +
                $t('lang.box_verifications.label_title')
            "
            color="white"
            no-padding
            class="col-12"
            :loading="shouldLoading"
          >
            <template v-slot:default>
              <skeleton-table :columns="5" v-if="shouldLoading" />

              <bx-table
                :data="data"
                :columns="columns"
                paginated
                :currentPage="page"
                :perPage="itemsPerPage"
                backendPagination
                v-if="!shouldLoading"
                :total="totalVerifications"
                @update:currentPage="updatePage"
              >
                <template slot-scope="props">
                  <bx-table-column centered>
                    <router-link
                      :to="{
                        name: 'Order_BoxVerificationView',
                        params: {
                          orderId: orderId,
                          boxId: id,
                          id: props.row.id
                        }
                      }"
                      class="bx-link bx-link-bold"
                      >{{ props.row.id }}</router-link
                    >
                  </bx-table-column>

                  <bx-table-column centered>            
                     
                    <router-link :to="{ name: 'Order_BoxVerificationViewItems', params: { orderId: orderId, boxId: id, id: props.row.id}}"
                      class="bx-link bx-link-bold">
                      VER DETALLE
                      </router-link>

                  </bx-table-column>
                  <bx-table-column centered>{{
                    formatDate(props.row.start_time)
                  }}</bx-table-column>
                  <bx-table-column centered>{{
                    formatDate(props.row.end_time)
                  }}</bx-table-column>
                  <bx-table-column centered>{{
                    props.row.real_item_count
                  }}</bx-table-column>
                <bx-table-column centered>{{props.row.readers[0]['serial_number']}}</bx-table-column>
                  <bx-table-column centered>
                    <bx-switch-dark
                      :value="props.row.valid"
                      @input="onValid(props.row)"
                    ></bx-switch-dark>
                  </bx-table-column>
                </template>
              </bx-table>
            </template>
          </bx-box>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BxBtn from "@/bx-components/BxBtn";
import BxSwitchDark from "@/bx-components/BxSwitchDark";
import BxOrderStatus from "@/bx-components/BxOrderStatus";
import moment from "moment";

export default {
  props: ["id", "orderId"],
  components: { BxOrderStatus, BxSwitchDark, BxBtn },
  data() {
    return {
      shouldLoading: true,
      columns: [],
      data: [],
      orderData: null,
      exit_date: "",
      waitingTime: "",
      name: "",
      order_status: 0,
      totalVerifications: 0,
      itemsPerPage: process.env.VUE_APP_ITEMS_PER_PAGE,
      page: 1
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    formatDate(date) {
      return date
        ? moment(date).format("DD/ MM/ YYYY, h:mm a")
        : this.$t("lang.messages.no_date_available");
    },
    updatePage(p) {
      this.page = p;
      this.getData();
    },
    async getData() {
      try {
        let orderData = (this.orderData = await this.$api.orders.get(
          this.orderId
        ));
        this.exit_date = orderData.exit_date;
        this.order_status = orderData.destination_status;
        this.waitingTime = orderData.waiting_time;
        this.name = orderData.order_name;

        let verifications = await this.$api.porders.getRBVerifications(this.id,{
          order_by: "-start_time",
          offset: (this.page - 1) * this.itemsPerPage,
          limit: this.itemsPerPage
        });

        this.data = verifications.results;
        this.totalVerifications = verifications.count;
      } catch (error) {
        console.error(error.message);
      } finally {
        this.columns = [
          {
            field: "id",
            label: "ID",
            centered: true
          },
          {
            field: "items",
            label: "ITEMS",
            centered: true
          },
          {
            field: "start_time",
            label: this.$t("lang.box_verifications.label_start_time"),
            centered: true
          },
          {
            field: "end_time",
            label: this.$t("lang.box_verifications.label_end_time"),
            centered: true
          },
          {
            field: "item_count",
            label: this.$t("lang.box_verifications.label_item_count"),
            centered: true
          },
          {
            field: "reader",
            label: this.$t("lang.admin.list_of_devices"),
            centered: true
          },
          {
            field: "valid",
            label: this.$t("lang.box_verifications.label_valid"),
            centered: true
          }
        ];
        this.shouldLoading = false;
      }
    },
    async onValid(data) {
      await this.$api.porders.setVerification({
        id: data.id,
        valid: !data.valid
      });
    }
  }
};
</script>
